import { useQuery } from '@hooks/reactQuery';

import { getConnectionLogsEventTypes } from '@api/networkElements';

import { nameTitleToOptionFormatted } from '@utils/formatter';

import { IOrganizationId } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_ELEMENT_TYPE_OPTIONS } from '@constants/queryKeys';

interface IUseQueryNetworkElementsEventTypesReturned {
	eventTypesOptions: TSelectOption[];
	isLoadingEventTypesOptions: boolean;
}

const useQueryNetworkElementsEventTypes = (
	params: Partial<IOrganizationId>,
): IUseQueryNetworkElementsEventTypesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_ELEMENT_TYPE_OPTIONS, params],
		queryFn: getConnectionLogsEventTypes,
		select: (data) => nameTitleToOptionFormatted(data),
		allowedRoles: [EUserRoles.smoLightUpdater, EUserRoles.smoLightViewer],
		...refetchOptions,
	});

	return {
		eventTypesOptions: data || [],
		isLoadingEventTypesOptions: (isLoading && !!data) || isFetching,
	};
};

export default useQueryNetworkElementsEventTypes;
